import * as React from 'react'
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Tooltip,
  Zoom,
} from '@mui/material'
import trovityLogo from 'src/assets/Header_Images/trovityLogo.svg'
import { makeStyles } from '@material-ui/core/styles'
import { useMutation } from '@apollo/client'
import LogoutIcon from '@mui/icons-material/Logout'
import { useKeycloak } from '@react-keycloak/web'
import { COLORS } from 'src/utils/Themes/colors'
import { UPDATE_USER_VERIFY } from 'src/services/individualService'
import {
  INPUT_FOCUS_KEYS,
  SUCCESSFULLY_UPDATED,
} from 'src/utils/constants/common'
import { OTP_SENT_SUCCESSFULLY } from 'src/utils/constants/CustomerReports'

const CheckMobile = (props) => {
  const classes = useStyles()
  const { keycloak } = useKeycloak()
  const [open, setOpen] = React.useState(true)
  const [openOTP, setOpenOTP] = React.useState(false)
  const [openField, setOpenField] = React.useState(true)
  const [messageInitial, setMessageInitial] = React.useState('')
  const [messageOTP, setMessageOTP] = React.useState('')
  const [mobileNumber, setMobileNumber] = React.useState('')
  const [emailValue, setEmailValue] = React.useState('')
  const [showMessageOTP, setshowMessageOTP] = React.useState(false)
  const [showMessageInitial, setshowMessageInitial] = React.useState(false)
  const [checkForMobile] = React.useState(
    !props?.mobileCheck || props.mobileCheck === '' ? true : false
  )
  const [checkForEmail] = React.useState(
    props?.emailCheck === undefined || props.emailCheck === '' ? true : false
  )
  const handleClose = () => {
    setOpen(false)
  }
  const phone = {
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
    otp5: '',
    otp6: '',
  }
  const email = {
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
    otp5: '',
    otp6: '',
  }
  const [mobileValues, setMobileValues] = React.useState(phone)
  const [emailValues, setEmailValues] = React.useState(email)

  const handleChange = (value1, event) => {
    setMobileValues({
      ...mobileValues,
      [value1]: event?.target?.value,
    })
  }
  const [userVerify] = useMutation(UPDATE_USER_VERIFY(), {
    onError(err) {
      setshowMessageOTP(true)
      setMessageOTP(err?.message)
    },
    onCompleted: () => {
      setMessageOTP(SUCCESSFULLY_UPDATED)
      window.location.reload()
    },
  })
  const [sendVerify] = useMutation(UPDATE_USER_VERIFY(), {
    onError(err) {
      setshowMessageInitial(true)
      setMessageInitial(err?.message)
    },
    onCompleted: () => {
      setOpenOTP(true)
      setOpenField(false)
    },
  })
  const [reSendOtpVerify] = useMutation(UPDATE_USER_VERIFY(), {
    onError(err) {
      setshowMessageOTP(true)
      setMessageOTP(err?.message)
    },
    onCompleted: () => {
      setshowMessageOTP(true)
      setMessageOTP(OTP_SENT_SUCCESSFULLY)
    },
  })
  const handleSubmitInitial = async (e) => {
    e.stopPropagation()
    e.preventDefault()
    sendVerify({
      variables: {
        emailId: emailValue,
        emailOtp: null,
        mobile: mobileNumber,
        mobileOtp: null,
        userName: props?.totalUserDetails?.userData?.userName,
      },
    })
  }
  const resendOTP = async (e) => {
    e?.stopPropagation()
    e?.preventDefault()
    emailValues.otp1 = ''
    emailValues.otp2 = ''
    emailValues.otp3 = ''
    emailValues.otp4 = ''
    emailValues.otp5 = ''
    emailValues.otp6 = ''
    mobileValues.otp1 = ''
    mobileValues.otp2 = ''
    mobileValues.otp3 = ''
    mobileValues.otp4 = ''
    mobileValues.otp5 = ''
    mobileValues.otp6 = ''
    reSendOtpVerify({
      variables: {
        emailId: emailValue,
        emailOtp: null,
        mobile: mobileNumber,
        mobileOtp: null,
        userName: props?.totalUserDetails?.userData?.userName,
      },
    })
  }
  const handleSubmit = async (e) => {
    e?.stopPropagation()
    e?.preventDefault()
    const emailOtp =
      emailValues.otp1 +
      emailValues.otp2 +
      emailValues.otp3 +
      emailValues.otp4 +
      emailValues.otp5 +
      emailValues.otp6
    const mobOtp =
      mobileValues.otp1 +
      mobileValues.otp2 +
      mobileValues.otp3 +
      mobileValues.otp4 +
      mobileValues.otp5 +
      mobileValues.otp6
    userVerify({
      variables: {
        emailId: emailValue,
        emailOtp: emailOtp,
        mobile: mobileNumber,
        mobileOtp: mobOtp,
        userName: props?.totalUserDetails?.userData?.userName,
      },
    })
  }
  const inputfocus = (elmnt) => {
    if (
      elmnt?.key === INPUT_FOCUS_KEYS?.Delete ||
      elmnt?.key === INPUT_FOCUS_KEYS?.Backspace
    ) {
      const next = elmnt?.target?.tabIndex - 1
      if (next > -1) {
        elmnt?.target?.form?.elements[next]?.focus()
      }
    } else {
      const next = elmnt?.target?.tabIndex + 1
      if (next < 100) {
        elmnt?.target?.form?.elements[next]?.focus()
      }
    }
  }
  const inputfocus1 = (elmnt) => {
    if (
      elmnt?.key === INPUT_FOCUS_KEYS?.Delete ||
      elmnt?.key === INPUT_FOCUS_KEYS?.Backspace
    ) {
      const next = elmnt?.target?.tabIndex - 1
      if (next > -1) {
        elmnt?.target?.form?.elements[next]?.focus()
      }
    } else {
      const next = elmnt?.target?.tabIndex + 1
      if (next < 100) {
        elmnt?.target?.form?.elements[next]?.focus()
      }
    }
  }
  const handleChangeEmail = (value1, event) => {
    setEmailValues({
      ...emailValues,
      [value1]: event?.target?.value,
    })
  }
  const mobileDisable = () => {
    return mobileNumber?.length === 10 ? false : true
  }
  const emailDisable = () => {
    return false
  }
  const opacityFunction = () => {
    if (
      (props?.mobileCheck === undefined || props?.mobileCheck === '') &&
      mobileNumber?.length !== 10
    ) {
      return 0.1
    } else {
      return 1
    }
  }
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose || 'backdropClick'}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <div className={classes.mobileCheckContainer}>
          <DialogTitle id='alert-dialog-title'>
            <div className={classes.imgContainer}>
              <img src={trovityLogo} alt='logo' textAlign='center' />
              <Tooltip
                TransitionComponent={Zoom}
                placement='bottom'
                title={'LogOut'}
                arrow
              >
                <LogoutIcon
                  className={classes.logoutIcon}
                  onClick={() => {
                    sessionStorage.clear()
                    keycloak.logout()
                  }}
                />
              </Tooltip>
            </div>
          </DialogTitle>
          {openField && (
            <div className={classes.openFieldContainer}>
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  <Alert
                    severity='warning'
                    backgroundColor='rgb(255, 244, 229)'
                  >
                    Please enter Missing Details to continue
                  </Alert>
                </DialogContentText>
              </DialogContent>
              <form onSubmit={handleSubmitInitial}>
                {checkForMobile && (
                  <div className={classes.checkForMobileContainer}>
                    <div className={classes.subMobileContainer}>
                      <TextField
                        placeholder='+91'
                        disabled
                        className={`${classes.customTextField} ${classes.numberinitField}`}
                      />
                    </div>
                    <div className={classes.enterValue}>
                      <TextField
                        name='mobile'
                        type='mobile'
                        placeholder='9876543210'
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e?.target?.value)}
                        required
                        inputProps={{ pattern: '[1-9]{1}[0-9]{9}' }}
                        className={`${classes.customTextField} ${classes.numberField}`}
                      />
                    </div>
                  </div>
                )}
                {checkForEmail && (
                  <div className={classes.checkForMailContainer}>
                    <div
                      className={`${classes.enterValue} ${classes.emailFieldContainer}`}
                    >
                      <TextField
                        name='email'
                        type='email'
                        placeholder='Email'
                        value={emailValue}
                        onChange={(e) => setEmailValue(e?.target?.value)}
                        className={`${classes.customTextField} ${classes.emailField}`}
                        inputProps={{
                          pattern:
                            '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.]{1}[a-zA-Z]{2,}$',
                        }}
                        required
                      />
                    </div>
                  </div>
                )}
                {showMessageInitial ? (
                  <div className={classes.showMessgeContainer}>
                    {messageInitial}
                  </div>
                ) : null}
                <DialogActions justifyContent='center'>
                  <div className={classes.dialogActionsContainer}>
                    <button
                      variant='contained'
                      className={classes.proceedButton}
                      style={{ opacity: opacityFunction() }}
                      disabled={
                        props?.mobileCheck === undefined ||
                        props?.mobileCheck === ''
                          ? mobileDisable()
                          : emailDisable()
                      }
                    >
                      Get Otp
                    </button>
                  </div>
                </DialogActions>
              </form>
            </div>
          )}
          {openOTP && (
            <form onSubmit={handleSubmit}>
              <div className={classes.openOtpContainer}></div>
              <button
                onClick={() => {
                  setOpenOTP(false)
                  setOpenField(true)
                  setshowMessageInitial(false)
                  setshowMessageOTP(false)
                  emailValues.otp1 = ''
                  emailValues.otp2 = ''
                  emailValues.otp3 = ''
                  emailValues.otp4 = ''
                  emailValues.otp5 = ''
                  emailValues.otp6 = ''
                  mobileValues.otp1 = ''
                  mobileValues.otp2 = ''
                  mobileValues.otp3 = ''
                  mobileValues.otp4 = ''
                  mobileValues.otp5 = ''
                  mobileValues.otp6 = ''
                }}
              >
                back
              </button>
              {checkForMobile && (
                <div>
                  <p className={classes.checkForContainer}>
                    OTP has been sent to +91 {mobileNumber}
                  </p>
                  <div className={classes.otpContainer}>
                    <input
                      name='otp1'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={mobileValues?.otp1}
                      onChange={(e) => handleChange('otp1', e)}
                      tabIndex={1}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus(e)}
                      required
                    />
                    <input
                      name='otp2'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={mobileValues?.otp2}
                      onChange={(e) => handleChange('otp2', e)}
                      tabIndex={2}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus(e)}
                      required
                    />
                    <input
                      name='otp3'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={mobileValues?.otp3}
                      onChange={(e) => handleChange('otp3', e)}
                      tabIndex={3}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus(e)}
                      required
                    />
                    <input
                      name='otp4'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={mobileValues?.otp4}
                      onChange={(e) => handleChange('otp4', e)}
                      tabIndex={4}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus(e)}
                      required
                    />
                    <input
                      name='otp5'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={mobileValues?.otp5}
                      onChange={(e) => handleChange('otp5', e)}
                      tabIndex={5}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus(e)}
                      required
                    />
                    <input
                      name='otp6'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={mobileValues?.otp6}
                      onChange={(e) => handleChange('otp6', e)}
                      tabIndex={6}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus(e)}
                      required
                    />
                  </div>
                </div>
              )}

              {checkForEmail && (
                <div>
                  <p className={classes.checkforEmailContainer}>
                    OTP has been sent to {emailValue}
                  </p>
                  <div className={classes.otpContainer}>
                    <input
                      name='otp1'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={emailValues?.otp1}
                      onChange={(e) => handleChangeEmail('otp1', e)}
                      tabIndex={1}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus1(e)}
                      required
                    />
                    <input
                      name='otp2'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={emailValues.otp2}
                      onChange={(e) => handleChangeEmail('otp2', e)}
                      tabIndex={2}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus1(e)}
                      required
                    />
                    <input
                      name='otp3'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={emailValues?.otp3}
                      onChange={(e) => handleChangeEmail('otp3', e)}
                      tabIndex={3}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus1(e)}
                      required
                    />
                    <input
                      name='otp4'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={emailValues?.otp4}
                      onChange={(e) => handleChangeEmail('otp4', e)}
                      tabIndex={4}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus1(e)}
                      required
                    />
                    <input
                      name='otp5'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={emailValues?.otp5}
                      onChange={(e) => handleChangeEmail('otp5', e)}
                      tabIndex={5}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus1(e)}
                      required
                    />
                    <input
                      name='otp6'
                      type='text'
                      autoComplete='off'
                      className={classes.otpInput}
                      value={emailValues?.otp6}
                      onChange={(e) => handleChangeEmail('otp6', e)}
                      tabIndex={6}
                      maxLength={1}
                      placeholder='*'
                      onKeyUp={(e) => inputfocus1(e)}
                      required
                    />
                  </div>
                </div>
              )}
              <div className={classes.resendContainer}>
                <button onClick={resendOTP} className={classes.resendBtn}>
                  Resend
                </button>
              </div>
              {showMessageOTP ? (
                <div className={classes.msgOtp}>{messageOTP}</div>
              ) : null}
              <div className={classes.submitContainer}>
                <button className={classes.proceedButton}>Submit</button>
              </div>
            </form>
          )}
        </div>
      </Dialog>
    </div>
  )
}

export default CheckMobile

const useStyles = makeStyles({
  button: {
    background: COLORS.MEDIUM_ORANGE,
    color: COLORS.WHITE,
    textTransform: 'unset',
    size: 'small',
    fontSize: '12px',
    fontWeight: 'bold',
    borderRadius: '12px',
    '&:hover': {
      backgroundColor: COLORS.MEDIUM_ORANGE,
    },
    marginTop: '5%',
  },
  imgContainer: { textAlign: 'center' },
  openFieldContainer: { margin: '0px' },
  checkForMobileContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  subMobileContainer: { width: '11%' },
  checkForMailContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  ctcButton: {
    padding: '1px 5px',
    borderRadius: '20px',
    border: '1px solid #32BEA6',
    backgroundColor: '#32BEA6',
    color: 'white',
    cursor: 'pointer',
  },
  mobileCheckContainer: { padding: '10px' },
  customTextField: {
    '& input::placeholder': {
      fontSize: '12px',
    },
  },
  dialogActionsContainer: { textAlign: 'center' },
  openOtpContainer: {
    display: 'flex',
  },
  submitContainer: { margin: '25px auto 5px auto', textAlign: 'center' },
  msgOtp: {
    margin: '15px auto 5px auto',
    color: 'red',
    width: '57%',
    fontSize: '15px',
    textAlign: 'center',
  },
  numberinitField: {
    '& .MuiInputBase-input': {
      padding: '0px 0px 4px 10px',
      borderBottomLeftRadius: '50px',
      borderTopLeftRadius: '50px',
      borderTop: '1px solid #BCBCBC',
      WebkitTextFillColor: '#333333 !important',
      fontWeight: 'bold',
    },
    '& .MuiInputBase-root': {
      borderBottomLeftRadius: '50px',
      borderTopLeftRadius: '50px',
    },
  },
  numberField: {
    '& .MuiInputBase-input': {
      padding: '0px 0px 4px 10px',
      borderBottomRightRadius: '50px',
      borderTopRightRadius: '50px',
      borderTop: '1px solid #BCBCBC',
      WebkitTextFillColor: '#333333 !important',
    },
    '& .MuiInputBase-root': {
      borderBottomRightRadius: '50px',
      borderTopRightRadius: '50px',
    },
  },
  resendBtn: {
    background: 'white',
    border: 'none',
    color: '#02A9F4',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  resendContainer: {
    padding: '7px',
    fontSize: '14px',
    margin: '1% 0% auto auto',
    textAlign: 'center',
    color: 'rgba(2, 169, 244, 1)',
  },
  checkforEmailContainer: {
    padding: '7px',
    fontSize: '12px',
    margin: '5% auto auto auto',
    textAlign: 'center',
    color: 'rgba(17, 47, 60, 0.6)',
  },
  checkForContainer: {
    padding: '7px',
    fontSize: '12px',
    margin: '5% auto auto auto',
    textAlign: 'center',
    color: 'rgba(17, 47, 60, 0.6)',
  },
  showMessgeContainer: {
    margin: '15px auto 5px auto',
    color: 'red',
    width: '57%',
    fontSize: '15px',
    textAlign: 'center',
  },
  emailField: {
    '& .MuiInputBase-input': {
      padding: '8px 50px 8px 10px',
    },
    '& .MuiInputBase-root': {
      borderRadius: '50px',
    },
  },
  enterValue: {
    width: '40%',
    paddingRight: '10px',
    '@media (min-width:1600px)': {
      width: '40%',
    },
  },
  otpInput: {
    width: '30px !important',
    height: '2rem',
    margin: '0 5px',
    fontSize: '25px',
    textAlign: 'center',
    borderRadius: '4px',
    border: '1px solid rgba(0, 0, 0, 0.3)',
    backgroundColor: 'rgba(232, 232, 232, 1)',
  },
  otpContainer: {
    margin: '2% auto auto auto',
    textAlign: 'center',
  },
  proceedButton: {
    textTransform: 'unset',
    backgroundColor: '#B92250',
    color: 'white',
    fontSize: '16px',
    padding: '10px 20px 10px 20px!important',
    borderRadius: '50px',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
  },
  logoutIcon: {
    float: 'right',
    cursor: 'pointer',
  },
  emailFieldContainer: {
    width: '60%',
  },
})
